import {
  Form,
  InputGroup
} from 'react-bootstrap'
import ReadOnlyField from './readonlyfield';

function ConfigShopify(props) {
  const default_json = {
    access_token: props.access_token,
    site_name: props.site_name,
    create_product_shopify: props.create_product_shopify
  };

  const onChangeCreateProductShopify = (e) => {
    default_json[e.target.name] = e.target.checked;
    props.onChange(default_json);
  }

  return (<>
    <h6>Configuración Shopify</h6>

    <Form.Group className="mb-3" controlId="formBasicCheckbox">
        <Form.Check
          type="switch"
          id="custom-switch"
          name='create_product_shopify'
          checked={props.create_product_shopify}
          onChange={onChangeCreateProductShopify}
          label={props.create_product_shopify ? "Crear producto habilitada":"Crear producto deshabilitada"}
        />
    </Form.Group>
    <ReadOnlyField controlId="formShopifyAccessToken" label="Access token">
      <Form.Control type="text" placeholder="Sin configurar en IM" value={props.access_token} name="access_token" readOnly disabled />
    </ReadOnlyField>

    <ReadOnlyField controlId="formShopifySiteName" label="Nombre del sitio">
      <InputGroup size="sm">
        <InputGroup.Text id="basic-addon2">https://</InputGroup.Text>
        <Form.Control type="text" placeholder="Sin configurar en IM" value={props.site_name} name="site_name" readOnly disabled />
        <InputGroup.Text id="basic-addon2">.myshopify.com</InputGroup.Text>
      </InputGroup>
    </ReadOnlyField>
  </>);
}


export default ConfigShopify;
